import PageContainer from "../../Components/PageContainer/PageContainer";
import WorkOrdersHeader from "./Components/WorkOrdersHeader/WorkOrdersHeader";
import styles from "./WorkOrders.module.css";
import { Table, Pagination } from "rsuite";
import { useWorkOrders } from "./useWorkOrders";
import {
  ActionsIcon,
  Status,
} from "../Settings/Components/Locations/Locations";
import WorkOrdersModal from "./Components/WorkOrdersModal/WorkOrdersModal";
import { useEffect } from "react";
import { useWorkOrdersModal } from "./Components/WorkOrdersModal/useWorkOrdersModal";
import { useWorkOrdersHeader } from "./Components/WorkOrdersHeader/useWorkOrdersHeader";
import DocumentTitle from "../../Components/DocumentTitle";
import moment from "moment";

const { Column, HeaderCell, Cell } = Table;

function WorkOrders() {
  let {
    workOrdersArrayLength,
    itemsPerPage,
    activePage,
    setActivePage,
    tableLoading,

    getWorkOrders,
    workOrders,
    sortColumn,
    handleSort,
  } = useWorkOrders();

  DocumentTitle("RitePMS Office - Work orders");

  let { showWorkOrdersModal } = useWorkOrdersModal();
  let { filter, period, plannedType } = useWorkOrdersHeader();

  useEffect(() => {
    getWorkOrders();
  }, [
    filter.locationId,
    filter.status,
    filter.number,
    filter.componentId,
    filter.jobId,
    filter.responsibleId,
    period.from,
    period.to,
    activePage,
    plannedType,
  ]);

  let StatusCell = ({ rowData, dataKey, ...props }) => {
    return (
      <>
        <Cell {...props}>
          <Status type={rowData[dataKey]} />
        </Cell>
      </>
    );
  };

  let ActionsCell = ({ rowData, dataKey, ...props }) => {
    return (
      <>
        <Cell {...props}>
          <div className={styles.actions_cell_container}>
            {rowData["status"] == "planned" ? (
              <ActionsIcon
                type="edit"
                onEdit={() => {
                  showWorkOrdersModal(rowData[dataKey]);
                }}
              />
            ) : (
              <ActionsIcon
                type="view"
                onView={() => {
                  showWorkOrdersModal(rowData[dataKey]);
                }}
              />
            )}
          </div>
        </Cell>
      </>
    );
  };

  let getRawStyle = (rowData) => {
    if (!rowData?.dueDate || !rowData?.plannedDate) return "";

    let style = "";
    let status = rowData?.status;

    let dateNow = moment().utc().startOf("day").format();
    let dueDate = moment(rowData.dueDateRaw).utc().startOf("day").format();
    let plannedDate = moment(rowData.plannedDateRaw)
      .utc()
      .startOf("day")
      .format();

    if (dueDate < plannedDate && status != "performed") style = "postponed";
    if (plannedDate < dateNow && status != "performed") style = "overDue";
    return style;
  };

  let allWorkOrders_section = (
    <>
      <WorkOrdersHeader />

      <div className={styles.table_container}>
        <div className={styles.table_scroll}>
          <Table
            className={styles.work_orders_table}
            sortColumn={sortColumn}
            onSortColumn={handleSort}
            loading={tableLoading}
            height={500}
            data={workOrders}
            onRowClick={(rowData) => {
              showWorkOrdersModal(rowData["_id"]);
            }}
            hover
            rowClassName={getRawStyle}
          >
            <Column minWidth={120} flexGrow={8} align="left" fixed>
              <HeaderCell>WO Number</HeaderCell>
              <Cell dataKey="workOrderNumber" />
            </Column>

            <Column minWidth={150} flexGrow={15} resizable>
              <HeaderCell>Component name</HeaderCell>
              <Cell dataKey="componentName" />
            </Column>

            <Column minWidth={150} flexGrow={15} resizable>
              <HeaderCell>Job name</HeaderCell>
              <Cell dataKey="jobName" />
            </Column>

            <Column minWidth={80} flexGrow={7} resizable>
              <HeaderCell>Vessel</HeaderCell>
              <Cell dataKey="locationName" />
            </Column>

            <Column minWidth={80} flexGrow={6}>
              <HeaderCell>Criticality</HeaderCell>
              <Cell dataKey="criticality" />
            </Column>

            <Column minWidth={80} flexGrow={6}>
              <HeaderCell>Responsible</HeaderCell>
              <Cell dataKey="responsible" />
            </Column>

            <Column sortable minWidth={70} flexGrow={7}>
              <HeaderCell>Due date</HeaderCell>
              <Cell dataKey="dueDate" />
            </Column>

            <Column sortable minWidth={70} flexGrow={7}>
              <HeaderCell>Planned date</HeaderCell>
              <Cell dataKey="plannedDate" />
            </Column>

            <Column minWidth={80} flexGrow={7}>
              <HeaderCell>Done date</HeaderCell>
              <Cell dataKey="doneDate" />
            </Column>

            <Column minWidth={80} flexGrow={7}>
              <HeaderCell>Status</HeaderCell>
              <Cell dataKey="status" />
            </Column>

            <Column minWidth={40} flexGrow={4}>
              <HeaderCell>Actions</HeaderCell>
              <ActionsCell dataKey="_id" />
            </Column>
          </Table>
        </div>

        <div className={styles.pagination_container}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            size="xs"
            layout={["total", "-", "pager"]}
            maxButtons={10}
            total={workOrdersArrayLength}
            limit={itemsPerPage}
            activePage={activePage}
            onChangePage={setActivePage}
          />
        </div>
      </div>

      <WorkOrdersModal />
    </>
  );

  //! Render

  return (
    <>
      <PageContainer>{allWorkOrders_section}</PageContainer>
    </>
  );
}

export default WorkOrders;
